'use client';
import React, { useState } from 'react';
import './HomePage.css';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import Category from './Category/Category';
import GermanyGuide from './GermanyGuide/GermanyGuide';
import ModalBox from '@/components/popupmodel/ModalBox';
import strings from '../../config/App.json';
import modalStrings from "../../config/modalStrings.json";
import { useRouter } from 'next/navigation';

const HomePage = () => {
  const router = useRouter();

  const [openModalType, setOpenModalType] = useState(null);

  const handleModalStateChange = (type, isOpen) => {
    setOpenModalType(isOpen ? type : null);
  };


  return (
    <main className="main-content">
      <div className="content-container">
        <Header />
        <GermanyGuide />
        <Category />
        <Footer />
      </div>
      <div className="background-container">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
      </div>

      <ModalBox
        type="newsletter"
        noOfTimesToShow={2}
        title={modalStrings.newsletter.title}
        text={modalStrings.newsletter.text}
        buttonText={modalStrings.newsletter.buttonText}
        showInput={true}
        autoShowDelay={3000}
        showOnEveryRefresh={true}
        isAnyModalOpen={openModalType !== null && openModalType !== "newsletter"}
        onModalStateChange={handleModalStateChange}
      />

      <ModalBox
        type="businessPopup"
        noOfTimesToShow={2}
        title={modalStrings.businessPopup.title}
        text={modalStrings.businessPopup.text}
        buttonText={modalStrings.businessPopup.buttonText}
        showInput={false}
        showOnEveryRefresh={true}
        autoShowDelay={5000}
        onSubmit={() => router.push(strings.ContactPage)}
        isAnyModalOpen={openModalType !== null && openModalType !== "businessPopup"}
        onModalStateChange={handleModalStateChange}
      />

    </main>
  );
};

export default HomePage;
